var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossRotatedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70968 9.75806L0.241935 1.37097C-0.0806451 1.04839 -0.0806451 0.645159 0.241935 0.322578C0.564516 -2.45124e-06 0.967743 -2.45124e-06 1.29032 0.322578L9.75806 8.79032C10.0806 9.1129 10.0806 9.51613 9.75806 9.83871C9.51613 10.0806 9.03226 10.0806 8.70968 9.75806Z",
    fill: "#3399FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75806 1.37097L1.29032 9.75806C0.967743 10.0806 0.564516 10.0806 0.241935 9.75806C-0.0806451 9.43548 -0.0806451 9.03226 0.241935 8.70968L8.70968 0.241935C9.03226 -0.0806451 9.43548 -0.0806451 9.75806 0.241935C10.0806 0.564516 10.0806 1.04839 9.75806 1.37097Z",
    fill: "#3399FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRotatedIcon);
export default __webpack_public_path__ + "static/media/cross-rotated-icon.a80acf0d.svg";
export { ForwardRef as ReactComponent };